import { render, staticRenderFns } from "./Proxmox.vue?vue&type=template&id=77cc8f8f"
import script from "./Proxmox.vue?vue&type=script&lang=js"
export * from "./Proxmox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports